"use client";

import { useStepInitialization } from "@/components/roadmap/step/resource/hooks/use-step-initialization";
import { Button } from "@/components/ui/button";
import { ArrowRightIcon } from "lucide-react";

export const RoadmapFirstTimeInPaths = ({ step }: { step: RoadmapStepVM }) => {
  useStepInitialization(step);

  return (
    <div className={"my-10 mb-[80vh] md:my-40"}>
      <h1 className={`my-2 text-center text-xl font-semibold`}>
        Ścieżka edukacyjna
      </h1>
      <div
        className={
          "mx-auto my-2 w-full max-w-[735px] text-center text-zinc-600"
        }
      >
        Nowy model uporządkowania treści – odkrywaj zagadnienia krok po kroku
        bez zbędnego chaosu. Korzystaj przy tym z różnorodnych materiałów
        wspierających Twoją naukę.
      </div>
      <div className={"mx-auto mt-8 flex flex-wrap justify-center gap-6"}>
        <Card
          title={"Czytaj"}
          desc={"Wiedza kliniczna i najnowsze wytyczne w przystępnej formie."}
          index="1"
        />
        <Card
          title={"Oglądaj"}
          desc={"Eksperckie wykłady i analizy zagadnień klinicznych."}
          index="2"
        />
        <Card
          title={"Utrwalaj wiedzę"}
          desc={"Interaktywne przypadki i quizy sprawdzające wiedzę."}
          index="3"
        />
        <Card
          title={"Słuchaj"}
          desc={"Treści audio bez konieczności patrzenia w ekran."}
          index="4"
        />
      </div>

      <div className={"mt-16 flex justify-center"}>
        <Button
          variant={"blue"}
          onClick={() => {
            window.location.reload();
          }}
        >
          Rozumiem <ArrowRightIcon />
        </Button>
      </div>
    </div>
  );
};

const Card = ({
  title,
  desc,
  index,
}: {
  title: string;
  desc: string;
  index: string;
}) => (
  <div className={"h-[272px] w-[224px] rounded-lg bg-black p-6 text-white"}>
    <video
      autoPlay={true}
      muted={true}
      loop={true}
      playsInline={true}
      className={
        "mx-auto block max-h-[140px] min-h-[140px] max-w-[140px] min-w-[140px]"
      }
    >
      <source
        src={`https://cdn.remedium.md/assets/roadmap/first-time-in-paths/${index}.mp4`}
        type="video/mp4"
      />
    </video>
    <div className={"text-center font-semibold"}>{title}</div>
    <div className={"text-center text-sm"}>{desc}</div>
  </div>
);
